import { AuthGraphQLProvider, AuthProvider } from '@codezo/auth';
import { useCallback } from 'react';
import { toast } from 'sonner';
import App from './App';
import { useAuth } from './hooks/useAuth';

function InitializeApp() {
	const { token } = useAuth();

	/* The safety net for an admin's guest preview. Every mutation but a tiny
	   allowlist is refused there, deny-by-default, so a control that was missed —
	   or one added later — surfaces the backend's own explanation instead of a
	   silent no-op. The message names the operation and is written to be shown. */
	const handleGuestPreviewBlocked = useCallback((message: string) => {
		toast.info(message, { id: 'guest-preview-blocked' });
	}, []);

	return (
		<AuthGraphQLProvider
			token={token || ''}
			uri={import.meta.env.VITE_GRAPHQL_ENDPOINT}
			audience="organization"
			onGuestPreviewBlocked={handleGuestPreviewBlocked}
		>
			<App />
		</AuthGraphQLProvider>
	);
}

export default function Initialize() {
	return (
		<AuthProvider>
			<InitializeApp />
		</AuthProvider>
	);
}
